import { GetCurrentStep } from "../../../../types/Step";
import { ViewKeyMap } from "../../../../types/Views";
import EventContextValueProvider from "../../Compositions/EventContextValueProvider";
import ComposableUserEventCreator, {
  IComposableUserEventCreatorConfig,
  IComposableUserEventCreatorProps
} from "../Components/ComposableUserEventCreator";
import StepOrViewArrivedEventFactory from "../Components/StepOrViewArrivedEventFactory";

export const isKnownStepOrViewPath = (path: string): boolean =>
  GetCurrentStep(path) !== undefined || Object.values(ViewKeyMap).some(v => v.uri === path);

const LocationUserEventCreator: React.FC<
  IComposableUserEventCreatorProps<string> & Pick<IComposableUserEventCreatorConfig<string>, "onChange">
> = props =>
  ComposableUserEventCreator({
    eventFactory: StepOrViewArrivedEventFactory,
    eventPredicate: isKnownStepOrViewPath,
    ...props
  });

const ComposedLocationUserEventCreator: React.FC<IComposableUserEventCreatorProps<string>> = EventContextValueProvider({
  Component: LocationUserEventCreator,
  map: ({ onUserEvent }) => ({ onChange: onUserEvent })
});

export default ComposedLocationUserEventCreator;
